import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const PoolingCenters = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [poolingCenterData, setPoolingCenterData] = useState([]);
    const [centerId, setCenterId] = useState(0);
    const [companyId, setCompanyId] = useState(0);
    const [centerName, setCenterName] = useState('');
    const [centerIncharge, setCenterIncharge] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [password, setPassword] = useState('');
    const [status, setStatus] = useState(1);
    const [isPasswordChanged, setIsPasswordChanged] = useState(false);

    const api = useApi();

    const loadCompanies = async () => {
        try {
            const _companies = await api.getCompanies();
            setCompanies(_companies);
        } catch (error) {
            alert('Unable to fetch companies.');
        }
    }

    const loadPoolingCenters = async () => {
        await api.getPoolingCenters().then((data) => {
            setPoolingCenterData(data);
        })
    }

    useEffect(() => {
        loadPoolingCenters();
    }, []);


    const addNewPoolingCenter = () => {
        loadCompanies();
        setCenterId(0);
        setCompanyId(0);
        setCenterName(null);
        setCenterIncharge(null);
        setMobileNo(null);
        setPassword(null);
        setStatus(1);
        setIsPasswordChanged(false);
        setModalVisible(true);
    }

    const editCenter = (pc) => {
        loadCompanies();
        setCenterId(pc.centerId);
        setCompanyId(pc.companyId);
        setCenterName(pc.centerName);
        setCenterIncharge(pc.centerIncharge);
        setMobileNo(pc.mobileNo);
        setPassword(pc.params);
        setStatus(pc.status);
        setIsPasswordChanged(false);
        setModalVisible(true);
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    const handleCompanyIdChange = (event) => {
        setCompanyId(event.target.value);
    };

    const handleCenterNameChange = (event) => {
        setCenterName(event.target.value);
    };

    const handleCenterInchargeChange = (event) => {
        setCenterIncharge(event.target.value);
    };

    const handleMobileNoChange = (event) => {
        setMobileNo(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setIsPasswordChanged(true);
    };

    const handleStatusChange = (event) => {
        setStatus(parseInt(event.target.value));
    };

     
    const onSavePoolingCenter = async () => {
        const params = {
            centerId,
            companyId,
            centerName,
            centerIncharge,
            mobileNo,
            password,
            status,
            isPasswordChanged: isPasswordChanged
        };

        await api.savePoolingCenter(params).then((data) => {
            loadPoolingCenters();
            setModalVisible(false);
        }).catch((error) => {
            console.error('Error saving pooling center :', error);
        });
    };


    const linkRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => editCenter(props.data)}>{cellValue}</span>
            </span>
        );
    };
    const statusRenderer = (props) => {
        const cellValue = (props.valueFormatted ? props.valueFormatted : props.value) === "1" ? 'Enabled' : 'Disabled';

        return (
            <span> {cellValue} </span>
        );
    };


    const columns = [
        { headerName: 'User Code', field: 'userCode', headerClass: 'text-center', cellClass: 'text-center', width: 80 },
        { headerName: 'Center Name', field: 'centerName', cellRenderer: linkRenderer, width: 250 },
        { headerName: 'Incharge Name', field: 'centerIncharge', width: 200 },
        { headerName: 'Company Name', field: 'companyName', width: 250,flex:1 },
        { headerName: 'Mobile Number', field: 'mobileNo', headerClass: 'text-center', cellClass: 'text-center', width: 150 },
        { headerName: 'Status', field: 'status', width: 100, cellRenderer: statusRenderer},
      
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };


    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Pooling Centers</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Pooling Centers</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        <button type="button" className="btn btn-primary my-2 btn-icon-text" onClick={addNewPoolingCenter}>
                            <i className="fe fe-edit me-2"></i> Add New Pooling Center
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div
                                style={{ height: 500 }}
                                className={"ag-theme-alpine"}
                            >
                                <AgGridReact
                                    gridOptions={gridOptions}
                                    rowData={poolingCenterData}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal backdrop="static" show={modalVisible}  onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add/Edit Pooling Center</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form autoComplete="off">
                   
                    <div className="form-group">
                        Auctioneer
                        <select
                            className="form-control select2-show-search select2-dropdown select2-hidden-accessible"
                            tabIndex="-1"
                            aria-hidden="true"
                            value={companyId}
                            onChange={handleCompanyIdChange}
                        >
                            <option label="Choose one"></option>
                            {companies?.map(t => {
                                return <option value={t.companyId}>{t.companyName}</option>
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        Pooling Center Name
                        <input className="form-control" placeholder="Center Name" type="text" value={centerName}
                            onChange={handleCenterNameChange} />
                    </div>
                    <div className="form-group">
                        Center Incharge Name
                        <input className="form-control" placeholder="Center Incharge Name" type="text" value={centerIncharge}
                            onChange={handleCenterInchargeChange} />
                    </div>
                    <div className="form-group">
                        Mobile Number
                            <input className="form-control" placeholder="Mobile Number" maxLength={10} type="text" value={mobileNo}
                            onChange={handleMobileNoChange} />
                    </div>
                    <div className="form-group">
                        Password
                            <input className="form-control" autoComplete="new-password" placeholder="Password" type="password" value={password}
                            onChange={handlePasswordChange} />
                    </div>

                    <div className="form-group">
                        Status
                        <div className="mg-l-20 d-flex">
                            <div className="mg-r-50">
                                <input name="status" type="radio" value="1" className="form-check-input" onChange={handleStatusChange} checked={status === 1} />
                                <label title="" className="form-check-label">Enabled</label>
                            </div>
                            <div>
                                <input name="status" type="radio" value="0" className="form-check-input" onChange={handleStatusChange} checked={status === 0} />
                                <label title="" className="form-check-label">Disabled</label>
                            </div>
                        </div>
                    </div>
                    
                    <div className="mg-t-10">
                        <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onSavePoolingCenter}>
                            Save
                        </button>
                        <button className="btn ripple btn-light pd-x-30" onClick={handleClose}>
                            Close
                        </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default PoolingCenters;



